module.exports = __webpack_public_path__ + "img/26.9cbbaf6d.jpg";